// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"05f05574","812":"2afaa80b","823":"011221e0"}[chunkId] + ".chunk.js";
};